export default __webpack_public_path__ + "static/media/industrialsite.13228be8.jpg";